/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import $ from "jquery";
import "dropify/dist/css/dropify.min.css";
import "dropify/dist/js/dropify.min.js";
// import axios from "axios";
import { InlineMath, BlockMath } from "react-katex";
import "katex/dist/katex.min.css";
import "./importQuestion.css";

import { Button } from "react-bootstrap";
// import { Editor } from "primereact/editor";
import api from "../../utils/api";
import he from "he"; // Import the 'he' library to decode HTML entities

import "react-toastify/dist/ReactToastify.css";

const fileTypes = [
  "JPG",
  "PNG",
  "GIF",
  "JPEG",
  "PDF",
  "DOC",
  "DOCX",
  "PPT",
  "PPTX",
  "XLS",
  "XLSX",
];

const PaperImport = () => {
  const [fetchedData, setFetchedData] = useState([]);
  const [selectedModule, setSelectedModule] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");
  const [selectedChapter, setSelectedChapter] = useState("");
  const [selectedTopic, setSelectedTopic] = useState("");
  const [fileDetails, setFileDetails] = useState({ questions: [] });
  const [ID, setID] = useState(null);
  const [modules, setModules] = useState([]);
  const [courses, setCourses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [chapters, setChapters] = useState([]);
  const [topics, setTopics] = useState([]);
  const [selectedQuestionType, setSelectedQuestionType] = useState("");
  const [questionType, setQuestionType] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSubmit, setShowSubmit] = useState(false);
  const [userPermissions, setUserPermissions] = useState({});
  const [loading, setLoading] = useState(false); // New state for loading

  const [fileUploaded, setFileUploaded] = useState(false);
  const {id} = useParams();

  

  useEffect(() => {
    auth();
  }, []);

  async function auth() {
    setLoading(true);
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const role = localStorage.getItem("role");
      const token = localStorage.getItem("authToken");
      const programType = "getPagePermission";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("role", role);
      fd.append("programType", programType);

      fd.append("pageNo", 8);

      const response = await api.post("user/userCurl", fd);
      // console.log("AUTH:", response.data.data[0]);

      if (response.data && response.data.data.length > 0) {
        setUserPermissions(response.data.data[0]); // Store permission data
      }
    } catch (error) {
      // console.error("Error fetching permissions:", error);
      setUserPermissions({});
      toast.error("Error fetching permissions.");
    } finally {
      setLoading(false);
    }
  }

  const handleFileChange = (event) => {
    if (event.target.files.length > 0) {
      setFileUploaded(true);
    } else {
      setFileUploaded(false);
    }
  };

  const [file, setFile] = useState(null);
  // const [fileDetails, setFileDetails] = useState(null); // Store file details
  const [showDetails, setShowDetails] = useState(false); // Toggle to show/hide file details

  const handleChange = (file) => {
    setFile(file);
    setFileDetails(null); // Reset file details on new upload
    setShowDetails(false); // Reset details view when a new file is uploaded
  };

  const handleAddQuestions = () => {
    toast.success("Questions added successfully!");
  };

  const toggleShowAnswer = (index) => {
    setFileDetails((prevDetails) => {
      const updatedQuestions = prevDetails.questions.map((question, idx) =>
        idx === index
          ? { ...question, showAnswer: !question.showAnswer }
          : question
      );
      return { ...prevDetails, questions: updatedQuestions };
    });
  };

  async function fetchModules() {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getAllDetails";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);

      const modulesResponse = await api.post("module/moduleCurl", fd);
      if (Array.isArray(modulesResponse.data.getResponse)) {
        setModules(modulesResponse.data.getResponse);
      } else {
        setModules([]);
      }
    } catch (error) {
      // console.error("Error fetching data:", error);
      setModules([]);
    }
  }

  async function fetchCourses(moduleId) {
    if (!moduleId) return setCourses([]);
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getCourseOnchange";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);
      fd.append("id", moduleId);

      const courseResponse = await api.post("onchange/onchangeCurl", fd);
      if (Array.isArray(courseResponse.data)) {
        setCourses(courseResponse.data);
      } else {
        setCourses([]);
      }
    } catch (error) {
      // console.error("Error fetching courses:", error);
      setCourses([]);
    }
  }

  async function fetchSubjects() {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getSubjectOnChange";
      const role = localStorage.getItem("role");

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);
      fd.append("role", role);

      const subjectResponse = await api.post("onchange/onchangeCurl", fd);
      // console.log("sub data:", subjectResponse.data);
      if (Array.isArray(subjectResponse.data.data)) {
        setSubjects(subjectResponse.data.data);
      } else {
        setSubjects([]);
      }
    } catch (error) {
      // console.error("Error fetching subjects:", error);
      setSubjects([]);
    }
  }

  async function fetchChapters(subjectId) {
    if (!subjectId) {
      // console.log("No module ID or course ID provided. Skipping API call.");
      setChapters([]);
      return;
    }

    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getChapterOnChange";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);

      fd.append("subjectId", subjectId); // Add subjectId

      const chapterResponse = await api.post("onchange/onchangeCurl", fd);
      // console.log("chapter Response:", chapterResponse);

      if (Array.isArray(chapterResponse.data.data)) {
        setChapters(chapterResponse.data.data);
      } else {
        setChapters([]);
      }
    } catch (error) {
      // // console.error("Error fetching subjects:", error);
      setChapters([]);
    }
  }

  async function fetchTopics(subjectId, chapterId) {
    if (!subjectId || !chapterId) {
      // // console.log("No module ID or course ID provided. Skipping API call.");
      setTopics([]);
      return;
    }

    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getTopicOnChange";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);

      fd.append("subjectId", subjectId); // Add subjectId
      fd.append("chapterId", chapterId); // Add chapterId

      const topicResponse = await api.post("onchange/onchangeCurl", fd);
      // console.log("Topic Response:", topicResponse);

      if (Array.isArray(topicResponse.data.data)) {
        setTopics(topicResponse.data.data);
      } else {
        setTopics([]);
      }
    } catch (error) {
      // // console.error("Error fetching subjects:", error);
      setTopics([]);
    }
  }

  useEffect(() => {
    if (selectedModule) {
      fetchCourses(selectedModule); // Ensure courses are fetched when module changes
    }
  }, [selectedModule]);

  useEffect(() => {
    if (selectedSubject) {
      fetchChapters(selectedSubject);
    } else {
      // Reset dependent fields when subject is removed
      setSelectedChapter("");
      setSelectedTopic("");
    }
  }, [selectedSubject]);
  

  useEffect(() => {
    if (selectedSubject && selectedChapter) {
      fetchTopics(selectedSubject, selectedChapter);
    } else {
      setSelectedTopic("");
    }
  }, [selectedSubject, selectedChapter]);

  
  
  const handleViewDetails = async () => {
    if (!file) {
      toast.warning("Please upload a file first.");
      return;
    }

    setIsLoading(true); // Set loading state for View Details button

    const loggedInUser = localStorage.getItem("loggedInUser");
    const token = localStorage.getItem("authToken");
    const programType = "viewQuestionsForPaper";

    const fd = new FormData();
    fd.append("programType", programType);
    fd.append("loggedInUser", loggedInUser);
    fd.append("token", token);
    fd.append("file", file);


    try {
      const response = await api.post("question/paperImport", fd);
      if (
        response.data &&
        Array.isArray(response.data) &&
        response.data.length > 0
      ) {
        const formattedQuestions = response.data.slice(1).map((row) => ({
          srNo: row[0],
          question: row[1],
          options: [row[2], row[3], row[4], row[5]],
          answer: row[6],
          explanation: row[7],
          tag: row[8],
          medium: row[9],
        }));

        setFileDetails({ questions: formattedQuestions });
        setShowDetails(true);
        setShowSubmit(true); // Show submit button after fetching questions
      } else {
        toast.error("No questions found in the uploaded file.");
        setFileDetails(null);
        setShowDetails(false);
      }
    } catch (error) {
      // console.error("Error parsing file:", error);
      toast.error("Failed to parse the uploaded file.");
      setFileDetails(null);
      setShowDetails(false);
    } finally {
      setIsLoading(false); // Reset loading state
    }
  };

  async function fetchQuestionType() {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getQuestionTypeDetails";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);

      const response = await api.post("questionType/questionTypeCurl", fd);
      // console.log("uuu data:", response.data);

      if (Array.isArray(response.data.getQuestionTypeDetails)) {
        setQuestionType(response.data.getQuestionTypeDetails);
      } else {
        // console.error("Data is not an array:", response.data);
        setQuestionType([]);
      }
    } catch (error) {
      // console.error("Error fetching data:", error);
      setQuestionType([]);
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();

    // Validate Required Fields
    if (
      !selectedModule
    ) {
      toast.error("Please select Class.");
      return;
    }
    if (
      !selectedSubject
    ) {
      toast.error("Please select Subject.");
      return;
    }
    if (
      !selectedChapter
    ) {
      toast.error("Please select Chapter.");
      return;
    }
    if (
      !selectedTopic
    ) {
      toast.error("Please select Topic.");
      return;
    }
    if (
      !selectedQuestionType
    ) {
      toast.error("Please select Question Type.");
      return;
    }

    // Validate File Input
    if (!file) {
      toast.error("Please upload a file before submitting.");
      return;
    }

    setIsSubmitting(true); // Set submitting state

    const loggedInUser = localStorage.getItem("loggedInUser");
    const token = localStorage.getItem("authToken");
    const programType = "importQuestionsForPaper";

    const fd = new FormData();
    fd.append("programType", programType);
    fd.append("loggedInUser", loggedInUser);
    fd.append("token", token);
    fd.append("module", selectedModule);
    fd.append("course", selectedCourse);
    fd.append("subject", selectedSubject);
    fd.append("chapter", selectedChapter);
    fd.append("topic", selectedTopic);
    fd.append("questionType", selectedQuestionType);
    fd.append("file", file);
    fd.append("paperId", id)

    

    console.log("Submitting Form Data:");
    for (let pair of fd.entries()) {
      console.log(pair[0] + ": " + pair[1]);
    }

    try {
      const response = await api.post("question/paperImport", fd);
      // console.log(response);

      if (response.data.status === true) {
        toast.success(response.data.message); // Show success message

        // Reset form fields after successful submission
        setSelectedModule("");
        setSelectedCourse("");
        setSelectedSubject("");
        setSelectedChapter("");
        setSelectedTopic("");
        setSelectedQuestionType("");
        setFile(null);
        setID(null);
        setErrorMessage(""); // Clear error message on success
      } else {
        const errorMessages = response.data.errors.map((errorData, index) => (
          <div key={index}>
            <p>
              ⚠️ <strong>{errorData.error}</strong>
            </p>
            <p>
              <strong>Question Id: {errorData.question_id}</strong>
            </p>
            <p>{renderLatexText(errorData.question)}</p>
            <hr />
          </div>
        ));

        setErrorMessage(errorMessages); // Set error message array
      }
    } catch (error) {
      // console.error("Error submitting form:", error);
      toast.error("Error submitting form. Please try again.");
    } finally {
      setIsSubmitting(false); // Reset submitting state
    }
  }

  const renderLatexText = (text) => {
    const decodedText = he.decode(text); // Decode HTML entities
    const latexAndImageRegex =
      /\\\((.*?)\\\)|\\\[(.*?)\\\]|<img[^>]*\bsrc=(["'])(.*?)\3[^>]*>|\\begin{align}([\s\S]*?)\\end{align}/g;

    const parts = [];
    let lastIndex = 0;

    decodedText.replace(
      latexAndImageRegex,
      (
        match,
        inlineLatex,
        blockLatex,
        quote,
        imageSrc,
        alignContent,
        index
      ) => {
        if (index > lastIndex) {
          parts.push(decodedText.slice(lastIndex, index));
        }

        if (imageSrc) {
          parts.push(
            <img
              key={index}
              src={imageSrc}
              alt="Image"
              style={{
                maxWidth: "50%",
                display: "inline",
                verticalAlign: "middle",
                marginLeft: "4px",
                marginRight: "4px",
              }}
            />
          );
        } else if (alignContent) {
          parts.push(
            <BlockMath
              key={index}
              style={{
                display: "block",
                textAlign: "center",
                margin: "10px 0",
                whiteSpace: "pre-line", // Preserves line breaks
              }}
            >
              {`\\begin{align}${alignContent}\\end{align}`}
            </BlockMath>
          );
        } else if (inlineLatex || blockLatex) {
          parts.push(
            <InlineMath
              key={index}
              style={{
                display: "inline",
                verticalAlign: "middle",
                marginLeft: "4px",
                marginRight: "4px",
              }}
            >
              {inlineLatex || blockLatex}
            </InlineMath>
          );
        }

        lastIndex = index + match.length;
      }
    );

    if (lastIndex < decodedText.length) {
      parts.push(decodedText.slice(lastIndex));
    }

    return <span style={{ whiteSpace: "normal" }}>{parts}</span>;
  };

  useEffect(() => {
    fetchModules();

    $(".dropify").dropify({
      messages: {
        default: "Drag and drop a file here or click",
        replace: "Drag and drop or click to replace",
        remove: "Remove",
        error: "Oops, something wrong happened.",
      },
    });

    // Handle file change
    $(".dropify").on("change", function (e) {
      const selectedFile = e.target.files[0];
      setFile(selectedFile);
      setFileDetails(null); // Reset file details
      setShowDetails(false); // Hide details when a new file is uploaded
    });
  }, []);

  useEffect(() => {
    fetchSubjects();
    fetchQuestionType();
  }, []);

  return (
    <div className="dashboard-body">
      <ToastContainer />

      {userPermissions.is_view === "0" ? (
        <div className="text-center mt-5">
          <h4 className="text-danger">Permission Denied</h4>
        </div>
      ) : (
        <>
          <div className="breadcrumb-with-buttons mb-24 flex-between flex-wrap gap-8">
            <div className="breadcrumb mb-24">
              <ul className="flex-align gap-4">
                <li>
                  <Link
                    to="/"
                    className="text-gray-200 fw-normal text-15 hover-text-main-600"
                  >
                    Home
                  </Link>
                </li>
                <li>
                  <span className="text-gray-500 fw-normal d-flex">
                    <i className="ph ph-caret-right"></i>
                  </span>
                </li>
                <li>
                  <span className="text-main-600 fw-normal text-15">
                    Import Question
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="card mt-24">
              <div className="card-header">
                <h4 className="mb-10">Chapter Details Add</h4>
                <div className="row gy-4">
                  <div className="col-12 col-md-4 col-lg-2">
                    {/* Select Module */}
                    <label htmlFor="moduleName" className="form-label mb-8 h6">
                      Select Class <span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                      className="form-control fw-medium mb-3"
                      value={selectedModule}
                      onChange={(e) => {
                        const moduleId = e.target.value;
                        setSelectedModule(moduleId);
                        // fetchCourses(moduleId);
                      }}
                    >
                      <option value="">Select a Class</option>
                      {modules.map((module) => (
                        <option key={module.id} value={module.id}>
                          {module.moduleName}
                        </option>
                      ))}
                    </select>
                  </div>
                  {/* <div className="col-12 col-md-4 col-lg-2">
                 
                    <label htmlFor="courseName" className="form-label mb-8 h6">
                      Select Course
                    </label>
                    <select
                      className="form-control fw-medium mb-3"
                      value={selectedCourse}
                      onChange={(e) => {
                        const courseId = e.target.value;
                        setSelectedCourse(courseId);
                       
                      }}
                    >
                      <option value="">Select a Course</option>
                      {courses.map((course) => (
                        <option key={course.id} value={course.id}>
                          {course.courseName}
                        </option>
                      ))}
                    </select>
                  </div> */}
                  <div className="col-12 col-md-4 col-lg-2">
                    {/* Select Subject */}
                    <label htmlFor="subjectName" className="form-label mb-8 h6">
                      Select Subject <span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                      className="form-control fw-medium mb-3"
                      value={selectedSubject}
                      onChange={(e) => {
                        const subjectId = e.target.value;
                        setSelectedSubject(subjectId);
                        // // console.log("Selected Subject ID:", e.target.value);
                        // fetchChapters(selectedModule, selectedCourse, subjectId);
                      }}
                    >
                      <option value="">Select a Subject</option>
                      {subjects.map((subject) => (
                        <option key={subject.id} value={subject.id}>
                          {subject.subjectName}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-12 col-md-4 col-lg-2">
                    {/* Select Chapter */}
                    <label htmlFor="chapterName" className="form-label mb-8 h6">
                      Select Chapter <span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                      className="form-control fw-medium mb-3"
                      value={selectedChapter}
                      onChange={(e) => {
                        const chapterId = e.target.value;
                        setSelectedChapter(chapterId);
                        // // console.log("Selected Chapter ID:", e.target.value);
                        // fetchTopics(
                        //   // selectedModule,
                        //   // selectedCourse,
                        //   // selectedSubject,
                        //   chapterId
                        // );
                      }}
                    >
                      <option value="">Select a Chapter</option>
                      {chapters.map((chapter) => (
                        <option key={chapter.id} value={chapter.id}>
                          {chapter.chapterName}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-12 col-md-4 col-lg-2">
                    {/* Select Topic */}
                    <label htmlFor="topicName" className="form-label mb-8 h6">
                      Select Topic <span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                      className="form-control fw-medium mb-3"
                      value={selectedTopic}
                      onChange={(e) => {
                        setSelectedTopic(e.target.value);
                      }}
                    >
                      <option value="">Select a Topic</option>
                      {topics.map((topic) => (
                        <option key={topic.id} value={topic.id}>
                          {topic.topicName}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-12 col-md-4 col-lg-2">
                    <label
                      htmlFor="questionType"
                      className="form-label mb-8 h6"
                    >
                      Question Type <span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                      className="form-control fw-medium"
                      value={selectedQuestionType}
                      onChange={(e) => {
                        setSelectedQuestionType(e.target.value);
                        // // console.log(
                        //   "Selected Question type ID:",
                        //   e.target.value
                        // ); // Debugging
                      }}
                    >
                      <option value="">Question Type</option>
                      {questionType.map((type) => (
                        <option key={type.id} value={type.id}>
                          {type.questionType}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>

            {errorMessage && (
              <div className="alert alert-danger mt-15" role="alert">
                {errorMessage} {/* This now renders multiple error messages */}
              </div>
            )}

            <div className="card mt-24">
              <div className="card-header">
                <div style={{ display: "flex" }}>
                  <label
                    htmlFor="fileUploader"
                    className="form-label mb-8 h6"
                    style={{ marginRight: "15px" }}
                  >
                    Upload File <span style={{ color: "red" }}>*</span>
                  </label>
                  <a
                    className="form-label mb-8 h6"
                    href="/Sample.docx"
                    style={{ color: "#3E80F9" }}
                    download
                  >
                    (Download Sample <i className="ph ph-link"></i>)
                  </a>
                </div>
                <input
                  type="file"
                  className="dropify"
                  id="fileUploader"
                  accept=".jpg,.png,.gif,.jpeg,.pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx"
                  onChange={handleFileChange}
                />
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Button
                    className="mt-15 btn btn-main rounded-pill p-10"
                    onClick={showSubmit ? handleSubmit : handleViewDetails} // Dynamically change function
                    disabled={isLoading || isSubmitting} // Disable on loading/submitting
                  >
                    {isLoading
                      ? "Loading..."
                      : isSubmitting
                      ? "Submitting..."
                      : showSubmit
                      ? "Submit"
                      : "View Details"}
                  </Button>
                </div>
              </div>
            </div>

            {fileDetails?.questions?.length > 0 ? (
              fileDetails.questions.map((question, index) => (
                <div key={index} className="card mt-24">
                  <div className="card-header">
                    <h5>
                      Question {question.srNo}){" "}
                      {renderLatexText(question.question)}
                    </h5>

                    <h6>Options:</h6>
                    <ul className="options-list">
                      {question.options.map((option, idx) => (
                        <li key={idx}>
                          {idx + 1}) {renderLatexText(option)}
                        </li>
                      ))}
                    </ul>
                    <hr style={{ borderTop: "1px dashed black" }}></hr>

                    <div style={{ display: "flex" }}>
                      <Button
                        onClick={() => toggleShowAnswer(index)}
                        className="btn btn-main rounded-pill p-10"
                        style={{ marginLeft: "auto", fontSize: "12px" }}
                      >
                        {question.showAnswer ? "Hide Answer" : "Show Answer"}
                      </Button>
                    </div>
                    {question.showAnswer && (
                      <div>
                        <p>
                          <strong>Explanation:</strong>{" "}
                          {renderLatexText(question.explanation)}
                        </p>
                        <p className="mt-10">
                          <strong>Answer:</strong>{" "}
                          {renderLatexText(question.answer)}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              ))
            ) : (
              <p></p>
            )}
          </form>
        </>
      )}
    </div>
  );
};

export default PaperImport;
